import PropTypes from 'prop-types';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
// @mui
import { Box, Stack, Drawer } from '@mui/material';
// hooks
import useResponsive from '../../../hooks/useResponsive';
// config
import { NAV, FOOTER } from '../../../config-global';
// components
import Logo from '../../../components/logo';
import Scrollbar from '../../../components/scrollbar';
import { NavSectionVertical } from '../../../components/nav-section';
//
// import navConfig from './config-navigation';
// import NavDocs from './NavDocs';
// import NavAccount from './NavAccount';
import NavToggleButton from './NavToggleButton';
import useNavConfig from './useNavConfig';
import NavRelationshipManager from './NavRelationshipManager';

// ----------------------------------------------------------------------

NavVertical.propTypes = {
  openNav: PropTypes.bool,
  onCloseNav: PropTypes.func,
  landingLogo: PropTypes.string,
};

export default function NavVertical({ openNav, onCloseNav, landingLogo }) {
  const { pathname } = useLocation();

  const isDesktop = useResponsive('up', 'lg');

  const navConfig = useNavConfig();

  useEffect(() => {
    if (openNav) {
      onCloseNav();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname]);

  const renderContent = (
    <Stack
      sx={{
        height: 1,
        // On desktop the fixed "Powered by" footer (DashboardLayout) covers the
        // bottom of this permanent drawer, so the whole nav stops above it. The
        // mobile drawer opens over the footer and needs no offset.
        pb: isDesktop ? `${FOOTER.H_DASHBOARD}px` : 0,
      }}
    >
      <Box sx={{ flexGrow: 1, minHeight: 0 }}>
        <Scrollbar
          sx={{
            height: 1,
            '& .simplebar-content': {
              height: 1,
              display: 'flex',
              flexDirection: 'column',
            },
          }}
        >
          <Stack
            spacing={3}
            sx={{
              pt: 2,
              pb: 2,
              px: 2.5,
              flexShrink: 0,
            }}
          >
            <Logo landingLogo={landingLogo} />
            {/* <NavAccount /> */}
          </Stack>

          <NavSectionVertical data={navConfig} />

          <Box sx={{ flexGrow: 1 }} />

          <Box sx={{ pb: 2 }} />
        </Scrollbar>
      </Box>

      {/* Outside the Scrollbar: stays pinned while the menu above scrolls. */}
      <NavRelationshipManager />
    </Stack>
  );

  return (
    <Box
      component="nav"
      sx={{
        flexShrink: { lg: 0 },
        width: { lg: NAV.W_DASHBOARD },
      }}
    >
      <NavToggleButton />

      {isDesktop ? (
        <Drawer
          open
          variant="permanent"
          PaperProps={{
            sx: {
              zIndex: 0,
              width: NAV.W_DASHBOARD,
              bgcolor: 'transparent',
              borderRightStyle: 'dashed',
            },
          }}
        >
          {renderContent}
        </Drawer>
      ) : (
        <Drawer
          open={openNav}
          onClose={onCloseNav}
          ModalProps={{
            keepMounted: true,
          }}
          PaperProps={{
            sx: {
              width: NAV.W_DASHBOARD,
            },
          }}
        >
          {renderContent}
        </Drawer>
      )}
    </Box>
  );
}
